import React, { useState, useEffect } from 'react'
import { css } from 'styled-components'
import { Theme } from '@styles/theme'

const breakpoints = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1140
}

const jsMedia = Theme.breakpoints.reduce(
  (acc, [label, size]) => ({
    ...acc,
    // max-width media query e.g. media.desktop
    [label]: (screen) => screen <= size,
    // min-width media query e.g. media.desktop_up
    [`${label}_up`]: (screen) => screen > size
  }),
  {}
)

export const useWindowWidth = () => {
  const isBrowser = typeof window !== 'undefined'
  const [width, setWidth] = useState(isBrowser ? window.innerWidth : 1140)

  useEffect(() => {
    if (!isBrowser) return <></>

    const handleResize = () => setWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return width
}

export const useMedia = (media) => {
  const width = useWindowWidth()
  return jsMedia[media](width)
}

export const useIsMobile = () => {
  const width = useWindowWidth()
  return width <= breakpoints.md
}

export const useIsDesktop = () => {
  const width = useWindowWidth()
  return width > breakpoints.md
}

export { breakpoints }
export const Mobile = `@media screen and (max-width: ${breakpoints.sm}px)`
export const Tablet = `@media screen and (max-width: ${breakpoints.md}px)`
export const Laptop = `@media screen and (max-width: ${breakpoints.lg}px)`
export const Desktop = `@media screen and (max-width: ${breakpoints.xl}px)`

export const margin = (props) => {
  return props.margin
    ? props.margin
    : `${props.top !== undefined ? props.top + 'rem' : 'auto'} ${
        props.right !== undefined ? props.right + 'rem' : 'auto'
      } ${props.bottom !== undefined ? props.bottom + 'rem' : 'auto'} ${
        props.left !== undefined ? props.left + 'rem' : 'auto'
      }`
}

export const marginZero = (props, defaultMargin = 0) => {
  return props.margin
    ? props.margin
    : `${props.top !== undefined ? props.top : defaultMargin}rem ${
        props.right !== undefined ? props.right : defaultMargin
      }rem ${props.bottom !== undefined ? props.bottom : defaultMargin}rem ${
        props.left !== undefined ? props.left : defaultMargin
      }rem`
}

export const padding = (props, defaultPadding = 0) => {
  return `${props.pTop !== undefined ? props.pTop : defaultPadding}rem ${
    props.pRight !== undefined ? props.pRight : defaultPadding
  }rem ${props.pBottom !== undefined ? props.pBottom : defaultPadding}rem ${
    props.pLeft !== undefined ? props.pLeft : defaultPadding
  }rem`
}

export const media = Theme.breakpoints.reduce(
  (acc, [label, size], i) => ({
    ...acc,
    // max-width media query e.g. media.desktop
    [label]: (...args) => css`
      @media only screen and (max-width: ${size}px) {
        ${css(...args)};
      }
    `,
    // min-width media query e.g. media.desktop_up
    [`${label}_up`]: (...args) => css`
      @media only screen and (min-width: ${Theme.breakpoints[i][1] + 1}px) {
        ${css(...args)};
      }
    `
  }),
  {}
)
